import { render } from "./registerView.vue?vue&type=template&id=6556ffce&scoped=true"
import script from "./registerView.vue?vue&type=script&lang=js"
export * from "./registerView.vue?vue&type=script&lang=js"

import "./registerView.vue?vue&type=style&index=0&id=6556ffce&lang=css"
import "./registerView.vue?vue&type=style&index=1&id=6556ffce&scoped=true&lang=css"
import "./registerView.vue?vue&type=style&index=2&id=6556ffce&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6556ffce"]])

export default __exports__